export default {
  "sections": {
    "volume": {
      "sectionName": "volume",
      "displayName": "Объем",
      "enums": {
        "volume": {
          "onChange": "onDetailChanged",
          "type": "block",
          "variation": "image",
          "hideHeader": true,
          "updatePrice": true,
          "hideTitle": true,
          "sectionClassName": "field-section--single",
        }
      }
    },
    "collar": {
      "sectionName": "collar",
      "displayName": "Воротник",
      "enums": {
        "collarDensity": {
          "onChange": "onDetailChanged",
          "type": "select",
          "inlineValue": true,
          "updatePrice": true,
          "updateRender": false,
          "sectionClassName": "field-section--single",
          "values": true,
          "defaulText": "Выберите плотность"
        },
        "group-breaker-density": {
          "type": "group-breaker",
        },
        "collarBone": {
          "onChange": "onDetailChanged",
          "type": "checkbox",
          "updateRender": false,
        },
        "collarButtons": {
          "onChange": "onDetailChanged",
          "type": "checkbox",
          "updateRender": false,
          "updatePrice": true,
        },
        "group-breaker-params": {
          "type": "group-breaker",
        },
        "collar": {
          "onChange": "onDetailChanged",
          "type": "block",
          "variation": "image",
          "hideHeader": true,
          "updatePrice": true,
          "updateRender": ["collar", "fabric"],
          "sectionClassName": "field-section--single",
          "hideTitle": true,
        },
      }
    },
    "sleeve": {
      "sectionName": "sleeve",
      "displayName": "Манжеты",
      "enums": {
        "sleeveType": {
          "attrName": "sleeveType",
          "displayName": "Длина рукава",
          "type": "toggle",
          "onChange": "onDetailChanged",
          "inlineValue": true,
          "updateRender": false,
          "updatePrice": false,
          "inline": true,
          "values": {
            "sleeveLong": {
              "attrValue": "sleeveLong",
              "displayName": "Длинный рукав",
              "shortName": "Длинный рукав",
            },
            "sleeveShort": {
              "attrValue": "sleeveShort",
              "displayName": "Короткий рукав",
              "shortName": "Короткий рукав",
            }
          }
        },
        "group-breaker-sleeve-type": {
          "type": "group-breaker",
        },
        "sleeveShort": {
          "attrName": "sleeve",
          "displayName": "Рукав",
          "type": "block",
          "variation": "image",
          "toggle": "sleeveType",
          "toggleItem": "sleeveShort",
          "inlineValue": true,
          "onChange": "onDetailChanged",
          "hideTitle": true,
          "values": {
            "sleeveShort": {
              "attrValue": "sleeveShort",
              "displayName": "Рукав короткий без планки",
              "shortName": "Короткий без планки",
            },
            "sleeveShortCuff": {
              "attrValue": "sleeveShortCuff",
              "displayName": "Рукав короткий с планкой",
              "shortName": "Короткий с планкой",
            }
          }
        },
        "cuffDensity": {
          "onChange": "onDetailChanged",
          "type": "select",
          "inlineValue": true,
          "toggleItem": "sleeveLong",
          "toggle": "sleeveType",
          "defaulText": "Выберите плотность",
          "values": true
        },
        "group-breaker-cuff-density": {
          "type": "group-breaker",
        },
        "cuff": {
          "type": "block",
          "variation": "image",
          "onChange": "onDetailChanged",
          "updateRender": ["cuff", "fabric"],
          "updatePrice": false,
          "toggle": "sleeveType",
          "toggleItem": "sleeveLong",
          "hideTitle": true,
        },
        "group-breaker-cuff": {
          "type": "group-breaker",
        },
        "cuffStyle": {
          "toggle": "sleeveType",
          "toggleItem": "sleeveLong",
          "type": "block",
          "variation": "image",
          "onChange": "onDetailChanged",
          "updatePrice": true,
          "updateRender": ["cuffStyle", "fabric"],
          "hideTitle": false,
        },
        "group-breaker-cuff-style": {
          "type": "group-breaker",
        },
      }
    },
    "fastening": {
      "sectionName": "fastening",
      "displayName": "Застежка",
      "enums": {
        "fastening": {
          "hideHeader": true,
          "updateRender": ["fastening", "fabric"],
          "onChange": "onDetailChanged",
          "type": "block",
          "variation": "image",
          "sectionClassName": "field-section--single",
          "hideTitle": true,
        }
      }
    },
    "pocket": {
      "sectionName": "pocket",
      "displayName": "Карманы",
      "enums": {
        "pocketButton": {
          "type": "checkbox",
          "onChange": "onDetailChanged",
          "sectionClassName": "field-section--groupped",
        },
        "pocketFlap": {
          "type": "checkbox",
          "onChange": "onDetailChanged",
          "sectionClassName": "field-section--groupped",
        },
        "pocket": {
          "updateRender": ["pocket", "fabric"],
          "type": "block",
          "variation": "image",
          "onChange": "onDetailChanged",
          "sectionClassName": "field-section--single",
          "hideTitle": true,
        }
      }
    },
    "backPleats": {
      "sectionName": "backPleats",
      "displayName": "Спинка",
      "enums": {
        "backPleats": {
          "type": "block",
          "onChange": "onDetailChanged",
          "variation": "image",
          "hideTitle": true,
        },
        "backPleatsHeader": {
          "type": "header",
          "hideTitle": false,
          "displayName": "Элементы отделки"
        },
        "handsDecor": {
          "type": "block-light",
          "hideTitle": false
        },
        "suspended": {
          "type": "checkbox",
          "onChange": "onDetailChanged",
        },
        "collarDecor": {
          "type": "checkbox",
          "onChange": "onDetailChanged",
        },
        "cuffDecor": {
          "type": "checkbox",
          "onChange": "onDetailChanged",
        },
      }
    },
    "buttons": {
      "sectionName": "buttons",
      "displayName": "Пуговицы",
      "enums": {
        "buttonThreadDecor": {
          "displayName": "Ручная пришивка пуговиц",
          "updateMaterial": "buttonThreadDecor",
          "type": "checkbox",
          "onChange": "onDetailChanged",
          "values": true
        },
        "buttons": {
          "updateMaterial": "buttons",
          "type": "button",
          "variation": "color",
          "onChange": "onButtonChanged"
        },
      }
    },
    "contrast": {
      "sectionName": "contrast",
      "displayName": "Контрасты",
      "enums": {
        "contrastType": {
          "attrName": "contrastType",
          "displayName": "Длина рукава",
          "type": "toggle-contrasts",
          "onChange": "onContrastTypeChanged",
          "inlineValue": true,
          "virtual": true,
          "values": [
            'collarFabric',
            'cuffFabric',
            'cuffTurnFabric',
            'collarStandFabric',
            'fasteningButtonsFabric',
          ]
        },
        "collarFabric": {
          "inlineValue": true,
          "type": "lazy-image-list",
          "toggle": "contrastType",
          "toggleItem": "collarFabric",
          "onChange": "onContrastChanged",
          "attrGroup": "fabrics",
          "values": true
        },
        "cuffFabric": {
          "inlineValue": true,
          "type": "lazy-image-list",
          "onChange": "onContrastChanged",
          "toggle": "contrastType",
          "toggleItem": "cuffFabric",
          "attrGroup": "fabrics",
          "values": true
        },
        "cuffTurnFabric": {
          "type": "lazy-image-list",
          "onChange": "onContrastChanged",
          "toggle": "contrastType",
          "toggleItem": "cuffTurnFabric",
          "inlineValue": true,
          "attrGroup": "fabrics",
          "values": true
        },
        "collarStandFabric": {
          "inlineValue": true,
          "type": "lazy-image-list",
          "toggle": "contrastType",
          "toggleItem": "collarStandFabric",
          "onChange": "onContrastChanged",
          "attrGroup": "fabrics",
          "values": true
        },
        "fasteningButtonsFabric": {
          "inlineValue": true,
          "type": "lazy-image-list",
          "onChange": "onContrastChanged",
          "toggle": "contrastType",
          "toggleItem": "fasteningButtonsFabric",
          "attrGroup": "fabrics",
          "values": true
        },
      }
    },
    "embroidery": {
      "sectionName": "embroidery",
      "displayName": "Монограмма",
      "enums": {
        "printProductNumber": {
          "onChange": "onDetailChanged",
          "price": 200,
          "type": "checkbox",
        },
        "group-breaker-embroidery-monogram": {
          "type": "group-breaker",
        },
        "embroideryText": {
          "conditionRender": true,
          "condition": {
            "type": 'formValue',
            "attrName": "printProductNumber",
            "attrValue": true,
          },
          "group-breaker-condition": {
            "type": "group-breaker",
          },
          "visibilityOwner": "printProductNumber",
          "onChange": "onDetailChanged",
          "type": "input",
          "placeholder": "ABC",
          "isFocused": true,
          "inlineValue": true,
          "sectionClassName": "field-section--single",
          "attrName": "embroideryText",
          "displayName": "Введите текст"
        },
        "group-breaker-embroidery-text": {
          "type": "group-breaker",
        },
        "separator": {
          "conditionRender": true,
          "condition": {
            "type": 'formValue',
            "attrName": "printProductNumber",
            "attrValue": true,
          },
          "visibilityOwner": "printProductNumber",
          "type": "separator",
          "variation": "line",
          "hideHeader": true,
          "hideLine": false,
          "sectionClassName": "field-section--single"
        },
        "embroideryFont": {
          "conditionRender": true,
          "condition": {
            "type": 'formValue',
            "attrName": "printProductNumber",
            "attrValue": true,
          },
          "visibilityOwner": "printProductNumber",
          "onChange": "onDetailChanged",
          "type": "font",
          "sectionClassName": "field-section--single"
        },
        "group-breaker-embroidery-font": {
          "type": "group-breaker",
        },
        "embroideryColor": {
          "conditionRender": true,
          "condition": {
            "type": 'formValue',
            "attrName": "printProductNumber",
            "attrValue": true,
          },
          "visibilityOwner": "printProductNumber",
          "onChange": "onDetailChanged",
          "shortName": "Цвет ниток",
          "type": "color",
          "sectionClassName": "field-section--single"
        },
        "group-breaker-embroidery-color": {
          "type": "group-breaker",
        },
        "embroidery": {
          "conditionRender": true,
          "condition": {
            "type": 'formValue',
            "attrName": "printProductNumber",
            "attrValue": true,
          },
          "excludedAttrs": [
            "embroideryNone"
          ],
          "visibilityOwner": "printProductNumber",
          "hideHeader": false,
          "onChange": "onDetailChanged",
          "type": "block-light2",
          "variation": "text",
          "sectionClassName": "field-section--single",
          "hideTitle": false,
        },
        "embroideryDescription": {
          "conditionRender": true,
          "condition": {
            "type": 'formValue',
            "attrName": "printProductNumber",
            "attrValue": false,
          },
          "text": `
          <p>Монограмма подчеркнет индивидуальность вашей рубашки.</p>
          <br/>
          <p>Выберите один из нескольких стилей,<br/> цветов и позиций.</p>
          `,
          "type": "text-field",
        }
      }
    },
  }
};
